<div class="modal inmodal fade in edit-permissions-modal" [ngClass]="{'show': ds.isEditPermissionModalShow}">
    <div class="modal-dialog">
        <div class="modal-content" [ngClass]="{'sk-loading': isPermissionsLoading}">
            <div class="modal-header">
                <button type="button" class="close" (click)="ds.hideEditPermissionModal()">
                    <span>×</span><span class="sr-only">Close</span>
                </button>
                <h4 class="modal-title">Edit {{modalType}}</h4>
            </div>
            <div class="modal-body">
                <form #form="ngForm" (submit)="onSubmit(form)" [ngClass]="{'ng-submitted': form.submitted}"
                      autocomplete="off">
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>{{modalType}} Name</label>
                        </div>
                        <div class="col-md-8">
                            <input type="text" name="name" class="form-control" [(ngModel)]="name">
                        </div>
                    </div>
                    
                    <div class="row m-b-xs"
                        *ngIf="!authenticationService.userIsResident && 
                                !(corporationNumbers.length == 1 &&
                                ds.selectedItemData.corporationNumbers.length == 1)">
                        <div class="col-md-4">
                            <label>Corporations</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="corporationNumbers"
                                                    required
                                                    [data]="corporationNumbers"
                                                    [(ngModel)]="ds.selectedItemData.corporationNumbers"
                                                    (onSelect)="getBuildingsForSelectedCorporations()"
                                                    (onDeSelect)="getBuildingsForSelectedCorporations($event, 'deselect')"
                                                    (onSelectAll)="getBuildingsForSelectedCorporations()"
                                                    (onDeSelectAll)="getBuildingsForSelectedCorporations($event, 'deselectAll')"
                                                    
                                                    (ngModelChange)="ds.onCorporationChange($event)"
                                                    [settings]="ds.multiselectSettings">
                            </angular2-multiselect>
                        </div>
                    </div>
                    
                    <div class="row m-b-xs"
                            *ngIf="!authenticationService.userIsResident && buildings.length &&
                            !(buildings.length == 1 &&
                            ds.selectedItemData.buildings.length == 1)">
                        <div class="col-md-4">
                            <label>Buildings</label>
                        </div>
                        <div  class="col-md-8">
                            <angular2-multiselect name="buildings"
                                                    required
                                                    [data]="buildings"
                                                    [(ngModel)]="ds.selectedItemData.buildings"
                                                    [settings]="ds.multiselectSettings"
                                                    (ngModelChange)="onBuildingsChange()">
                            </angular2-multiselect>
                        </div>
                    </div>
                    
                    <div class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Sharing</label>
                        </div>
                        <div class="col-md-8">
                            <select class="form-control" name="isPublic" [(ngModel)]="shareType">
                                <option [ngValue]="null">Staff only</option>
                                <option *ngFor="let option of currentShareTypeOptions" [ngValue]="option.value">{{option.name}}</option>
                            </select>
                        </div>
                    </div>

                    <div *ngIf="shareType == shareTypes.Residents" class="row m-b-sm">
                        <div class="col-md-4">
                            <label>Occupancy Types</label>
                        </div>
                        <div class="col-md-8">
                            <permissions-select [permissionsList]="permissionsList"
                                                [permissions]="permissions"
                                                (onChange)="onPermissionsChange($event)">
                            </permissions-select>
                        </div>
                    </div>
                    <div *ngIf="shareType == shareTypes.Groups" class="row m-b-sm">
                        <div class="col-md-4">
                            <label>User Groups</label>
                        </div>
                        <div class="col-md-8">
                            <angular2-multiselect name="userGroups"
                                                  required
                                                  [data]="currentUserGroups"
                                                  [(ngModel)]="userGroups"
                                                  [settings]="{
                                                      singleSelection: false,
                                                      text: 'Select User Groups',
                                                      selectAllText: 'Select All',
                                                      unSelectAllText: 'Deselect All',
                                                      enableSearchFilter: true,
                                                      classes: 'with-filter'
                                                  }">
                            </angular2-multiselect>
                        </div>
                    </div>

                    <div class="btns-box">
                        <!-- <button [class.visible]="permissionsList.length" -->
                        <button type="submit"
                                class="btn btn-primary save-folder-btn m-t-md visible">
                            Save
                        </button>
                        <!-- <button [class.visible]="!permissionsList.length"
                                (click)="ds.hideEditPermissionModal()"
                                type="button"
                                class="btn btn-primary save-folder-btn m-t-md">
                            Close
                        </button> -->
                    </div>
                </form>
            </div>
        </div>

        <spinner [spinnerShow]="isPermissionsLoading && isCorporationLoading"></spinner>
    </div>
    <div class="modal-backdrop fade in" (click)="ds.hideEditPermissionModal()"></div>
</div>



// WEBPACK FOOTER //
// /app/src/app/views/documents/edit-permissions-modal/edit-permissions-modal.component.html